$(document).on("click", ".add-stop-to-favourites", function() {
    if($(this).find(".to-add").hasClass("hidden")) {
        removeValueFromCookie('favouriteStops', $(this).attr("data-stop"), 10000);
        $(this).find(".to-remove").addClass("hidden");
        $(this).find(".to-add").removeClass("hidden");
    } else {
        addValueToCookie('favouriteStops', $(this).attr("data-stop"), 10000);
        $(this).find(".to-add").addClass("hidden");
        $(this).find(".to-remove").removeClass("hidden");
    }
});